<template>
  <AppAccordionItem
    v-if="strapiData || typeof props.data.text === 'string'"
    :accordion-index="accordionIndex"
    :accordion-active-index="accordionActiveIndex"
    :theme="theme"
    class="block-accordion-element"
  >
    <template #title>
      <AtomHeading
        :tag="theme === 'primary' ? 'h3' : 'h4'"
        :appereance="theme === 'primary' ? 'h3' : 'h4'"
        :text="data.title"
      />
    </template>
    <template #text>
      <AtomRichtext
        :string="strapiDataKey ? data.text : null"
        :data="!strapiDataKey ? data : null"
        :is-strapi="false"
      />
    </template>
  </AppAccordionItem>
  <AppAccordionItem
    v-else-if="!data.strapi_data_key"
    :accordion-index="accordionIndex"
    :accordion-active-index="accordionActiveIndex"
    :theme="theme"
    class="block-accordion-element"
  >
    <template #title>
      <AtomHeading
        :tag="theme === 'primary' ? 'h3' : 'h4'"
        :appereance="theme === 'primary' ? 'h3' : 'h4'"
        :text="data.title"
      />
    </template>
    <template #text>
      <AtomRichtext
        v-if="useHTML"
        :html="data.textCompendium"
        :is-strapi="false"
      />
      <AtomRichtext
        v-else
        :string="strapiDataKey ? data.text : null"
        :data="!strapiDataKey ? data : null"
        :is-strapi="false"
      />
    </template>
  </AppAccordionItem>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
    accordionIndex: {
        type: Number,
        required: true,
    },
    accordionActiveIndex: {
        type: Number,
        required: true,
    },
    theme: {
        type: String,
        required: true,
    },
    strapiDataKey: {
        type: String,
        default: '',
    },
});

/*
  Inject useHTML from parent component
*/
const useHTML = inject('useHTML', false);

/*
  Get strapi data
*/
const strapiData = computed(() => {
    if (props.data.strapi_data_key) {
        const storyStore = useStoryStore();
        return storyStore.getConnectedStrapiValue(props.data.strapi_data_key);
    }
    return false;
});

</script>

<style lang="scss">
.block-accordion-element {
    .atom-heading {
        @include typo-font('regular');

        margin-bottom: 0;
    }
}
</style>
